import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserSettingsProfileRequestChangeModalComponent } from './user-settings-profile-request-change-modal.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [UserSettingsProfileRequestChangeModalComponent],
})
export class UserSettingsProfileRequestChangeModalModule {}
